import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { IonInput, IonModal } from '@ionic/angular';
import { ColumnMode, DatatableComponent, SelectionType, SortType } from '@swimlane/ngx-datatable';
import { DataService } from 'src/app/data.service';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import moment from 'moment';
import { firstValueFrom } from 'rxjs';
import { ORAADO_JOGVISZONY, hetiOraszam, oraadoJogviszony } from 'src/app/shared/oraado';

@Component({
  selector: 'app-allomany',
  templateUrl: './allomany.component.html',
  styleUrls: ['./allomany.component.scss'],
})
export class AllomanyComponent  implements OnInit {

  protected readonly ColumnMode = ColumnMode;
  protected readonly SortType = SortType;
  protected readonly JSON = JSON;

  sajatIntezmeny
  intezmeny=2
  dolgozok=0
  tanulok=0
  felulet=0
  import=0
  besorolas=0
  enaplo=0
  dokumentumok=0
  adatszolg=0
  penzugy=0
  modulok=0
  munkatarssorok=[];
  datetime
  alkalmazk
  alkalmazv
  allomanySzurt = [];
  allomanyRequiredFields: { allomany: string[]; allomany_feladatellatas: string[] } = {
    allomany: [],
    allomany_feladatellatas: [],
  };
  szuro = {
    nev: '',
    oktazon: '',
    adid: '',
  };
  private readonly allomanyFormFields = new Set([
    'viselt_elo',
    'viselt_vez',
    'viselt_ker',
    'szul_elo',
    'szul_vez',
    'szul_ker',
    'anya_elo',
    'anya_vez',
    'anya_ker',
    'taj',
    'adoazon',
    'ig_tipus',
    'ig_szam',
    'szul_datum',
    'oktazon',
    'szul_hely',
    'szul_orszag',
    'anyanyelv',
    'allampolgar1',
    'allampolgar2',
    'nem',
    'email',
    'telefonszam',
  ]);
  private readonly allomanyFeladatellatasFormFields = new Set([
    'munkakor',
    'szszam',
    'jogviszony_kezd',
    'jogviszony_vege',
    'foallas',
    'ped_fokozat',
    'munkaviszony',
    'utazo_gyogyped',
    'csok_mi',
    'tartos_tavollet',
    'vezeto',
    'ttf',
    'reszm_arany',
    'heti_oraszam',
    'megbizasi_oradij',
    'benzinkm',
    'utazas_utvonal',
    'utazas_eszkoz',
    'utazas_rendszam',
  ]);
  private readonly fieldLabels = {
    oktazon: 'Oktatási azonosító',
    viselt_ker: 'Utónév',
    anyanyelv: 'Anyanyelv',
    foallas: 'Főállás',
    ped_fokozat: 'Pedagógus fokozat',
    munkaviszony: 'Jogviszony',
    utazo_gyogyped: 'Utazó gyógypedagógus',
    csok_mi: 'Csökkent munkaképességű',
    tartos_tavollet: 'Tartós távollét',
    vezeto: 'Vezető beosztás',
    ttf: 'TTF',
    benzinkm: 'Napi km (oda-vissza)',
    utazas_utvonal: 'Útvonal',
    utazas_eszkoz: 'Közlekedési eszköz',
    utazas_rendszam: 'Rendszám',
  };

  selected = [];
  telepules
  allampolgar
  orszag
  SelectionType = SelectionType;
  allomany
  /*  A rendszer jogkörei – a munkatárs adatlapján ebből lehet választani.
   *  Ugyanaz a kör, amit a Jogosultságok képernyő szerkeszt: ha itt más lista
   *  lenne, két helyen kellene karbantartani ugyanazt a fogalmat. */
  jogkorok: any[] = [];
  alrendszer = 'SULINFORM';
  csoport
  activeAllomany: any = null;
  activeIntezmenyAdatok: any = null;
  @ViewChild("uzenetmodal") modal: IonModal;
  @ViewChild("allomanyTable") allomanyTable: DatatableComponent;
  segment="1"

  portControl: FormControl;
  form: FormGroup;

  constructor(private http: HttpClient,private data: DataService,
    private formBuilder: FormBuilder) {
      this.portControl = this.formBuilder.control(
        {id:142,nev:"magyar"},
        Validators.required
      );
      this.form = this.formBuilder.group({
        anyanyelv: new FormControl({id:142,nev:"magyar"},Validators.required),
        allampolgar1: new FormControl({id:142,nev:"magyar"},Validators.required),
        allampolgar2: new FormControl({id:142,nev:"magyar"},Validators.required),
        alkalmazk: new FormControl("",Validators.required),
        alkalmazv: new FormControl(""),
        jogkor: new FormControl(""),
        szul_orszag: new FormControl({id:142,nev:"Magyarország"},Validators.required),
        viselt_elo: new FormControl(""),
        viselt_vez: new FormControl(""),
        viselt_ker: new FormControl(""),
        taj: new FormControl(""),
        szul_elo: new FormControl(""),
        szul_vez: new FormControl(""),
        szul_ker: new FormControl(""),
        anya_elo: new FormControl(""),
        anya_vez: new FormControl(""),
        anya_ker: new FormControl(""),
        adoazon: new FormControl(""),
        ig_tipus: new FormControl(""),
        ig_szam: new FormControl(""),
        szul_datum: new FormControl(""),
        oktazon: new FormControl(""),
        szul_hely: new FormControl(""),
        nem: new FormControl(""),
        email: new FormControl(""),
        telefonszam: new FormControl(""),
        /*  LAKCÍMEK. Az adatbázis évek óta tárolta mind a tizenkét mezőt, a
         *  „Cím és elérhetőség" fülön viszont csak egy üres, működésképtelen
         *  táblázat állt a helyükön - vagyis a munkatárs lakcímét sehol nem
         *  lehetett rögzíteni, pedig a KIR-adatszolgáltatás kéri. */
        all_cim_irsz: new FormControl(""),
        all_cim_telepules: new FormControl(""),
        all_cim_kozter: new FormControl(""),
        all_cim_kozter_jelleg: new FormControl(""),
        all_cim_hsz: new FormControl(""),
        all_cim_pontositas: new FormControl(""),
        tart_cim_irsz: new FormControl(""),
        tart_cim_telepules: new FormControl(""),
        tart_cim_kozter: new FormControl(""),
        tart_cim_kozter_jelleg: new FormControl(""),
        tart_cim_hsz: new FormControl(""),
        tart_cim_pontositas: new FormControl(""),
        vegzettseg: new FormControl(""),
        
        munkakor: new FormControl(""),
        szszam: new FormControl(""),
        jogviszony_kezd:new FormControl(""),
        jogviszony_vege:new FormControl(""),
        foallas:new FormControl(0),
        ped_fokozat:new FormControl("0"),
        munkaviszony:new FormControl(0),
        utazo_gyogyped:new FormControl(0),
        csok_mi:new FormControl(0),
        tartos_tavollet:new FormControl(0),
        vezeto:new FormControl(0),
        ttf:new FormControl(0),
        reszm_arany: new FormControl(""),
        //  Óraadó (megbízás): az arány helyett a szerződés szerinti heti óraszám és az óradíj.
        heti_oraszam: new FormControl(""),
        megbizasi_oradij: new FormControl(""),
        //  Munkába járás: napi km (allomany_feladatellatas.benzinkm), útvonal, eszköz, rendszám.
        benzinkm: new FormControl(""),
        utazas_utvonal: new FormControl(""),
        utazas_eszkoz: new FormControl(""),
        utazas_rendszam: new FormControl(""),
      }); 
     }

  async ngOnInit() {
    this.sajatIntezmeny = (await this.data.getFromStorage("sajatIntezmeny"))
    // Az alrendszert a tárolt belépési mód adja; a `sajatIntezmeny.mode` alakja
    // telepítésenként eltér (volt már parse-olatlan szövegként is).
    this.alrendszer = (await this.data.getFromStorage("currentMode")) || 'SULINFORM'
    
    this.getAllomanyRequiredFields();
    this.getAllomany();
  }


  getRowClass = (row) => {
    return {
      'row-color-blue': row.priority == 1,
      'row-color-green': row.priority == 2,
      'row-color-orange': row.priority == 3,
      'row-color-red': row.priority == 4,
    };
  }

  /*  Új munkatárs felvitele. Az azonosító (adid) itt dől el, és utána nem változtatható –
   *  ez köti össze a jogosultságokkal, órarenddel, bérrel. Ezért az e-mail címből (SSO)
   *  vagy az oktatási azonosítóból képezzük, ugyanúgy, ahogy a KIR-import teszi. */
  /**
   *  Jelenléti ív a dolgozókról – PDF (backend/jelenleti.js, a munkaidő-elszámolás arculatával).
   *
   *  `kor`: 'tanar' (pedagógus munkakörűek), 'egyeb' (a többiek), 'mind'.
   *  Új lapon nyílik, hogy a nyomtatás előtt látható legyen, mi kerül papírra.
   */
  jelenletiIv(kor: 'tanar' | 'egyeb' | 'mind') {
    const intezmeny = String(this.sajatIntezmeny?.intezmenyId || '').trim();
    if (!intezmeny) return;
    this.data.megnyitFajl(`/api/jelenleti/dolgozo/${kor}/${intezmeny}`, 'jelenleti-iv');
  }

  ujAllomany() {
    const email = String(prompt('Az új munkatárs e-mail címe (ez lesz a belépési azonosító is):') || '').trim();
    if (!email) return;
    if (!email.includes('@')) { this.data.sendToast('Érvényes e-mail címet adj meg.', 'error'); return; }
    const adid = email.toLowerCase();
    if ((this.allomany || []).some((a: any) => String(a.adid).toLowerCase() === adid)) {
      this.data.sendToast('Ezzel az azonosítóval már van munkatárs.', 'warning');
      return;
    }
    this.initModal({
      adid,
      email,
      intezmenyadatok: JSON.stringify([{ intezmenyId: this.sajatIntezmeny?.intezmenyId, feladatellatas: this.sajatIntezmeny?.intezmenyId }]),
    });
  }

  /** Munkatárs törlése – csak ha nincs hozzá kötött óra, TTF-sor vagy kinevezés. */
  allomanyTorol(row: any) {
    const nev = `${row?.viselt_vez || ''} ${row?.viselt_ker || ''}`.trim();
    if (!confirm(`Biztosan törlöd a munkatársat?\n\n${nev} (${row?.adid})\n\nHa már van hozzá óra, TTF-sor vagy kinevezés, a törlés helyett a jogviszony lezárása a helyes út.`)) return;
    this.http.delete(`/api/nyilvantartas/allomany/${encodeURIComponent(row.adid)}`).subscribe({
      next: () => { this.data.sendToast('Munkatárs törölve.', 'success'); this.getAllomany(); },
      error: (e: any) => this.data.sendToast(e?.error?.error || 'A törlés nem sikerült.', 'error'),
    });
  }

  /* ── Lakcím ─────────────────────────────────────────────────────────── */

  /** A tartózkodási cím kitöltése az állandóból – a leggyakoribb eset. */
  tartCimAzAllandobol() {
    const v = this.form.value;
    this.form.patchValue({
      tart_cim_irsz: v.all_cim_irsz,
      tart_cim_telepules: v.all_cim_telepules,
      tart_cim_kozter: v.all_cim_kozter,
      tart_cim_kozter_jelleg: v.all_cim_kozter_jelleg,
      tart_cim_hsz: v.all_cim_hsz,
      tart_cim_pontositas: v.all_cim_pontositas,
    });
  }

  /* ── E-mail változás átvezetése (belépési azonosító) ─────────────────── */

  /*  A belépési azonosító (adid) felvételkor az e-mail címből keletkezik, és
   *  utána az egész rendszer ezzel hivatkozik a kollégára. Ha az e-mail cím
   *  megváltozik, az azonosító a RÉGI címen marad: az új címmel nem tud belépni,
   *  a régivel pedig - ha a levelezésben megszűnt - szintén nem.
   *
   *  Kézzel átírni nem lehet, mert az összes hivatkozás elárvulna. Ezért ez a
   *  blokk: előbb MEGMUTATJA, hol szerepel a régi azonosító, és csak utána vezet át.
   */
  migTalalatok: any[] = null;
  migOsszes = 0;
  migFut = false;

  /** Akkor van mit átvezetni, ha az azonosító e-mail alakú és eltér a mostani címtől. */
  get migSzukseges(): boolean {
    const adid = String(this.activeAllomany?.adid || '').trim();
    const email = String(this.form?.value?.email || '').trim();
    return !!adid && adid.includes('@') && !!email
      && adid.toLowerCase() !== email.toLowerCase();
  }

  get migRegi(): string { return String(this.activeAllomany?.adid || '').trim(); }
  get migUj(): string { return String(this.form?.value?.email || '').trim(); }

  async migElonezet() {
    this.migFut = true;
    this.migTalalatok = null;
    try {
      const p = new URLSearchParams({ regi: this.migRegi, uj: this.migUj });
      const r: any = await firstValueFrom(this.http.get(
        '/api/nyilvantartas/allomany-azonosito/elonezet?' + p.toString()));
      this.migTalalatok = (r?.elofordulasok || []).map((e: any) => ({
        ...e,
        // A megjelölt (külső rendszerhez tartozó) találatok alapból NINCSENEK bepipálva.
        valasztva: !!e.kotelezo || !e.gyanus,
      }));
      this.migSzamol();
    } catch (e: any) {
      this.migTalalatok = null;
      this.data.sendToast(e?.error?.error || 'Az előnézet lekérése nem sikerült.', 'error');
    } finally {
      this.migFut = false;
    }
  }

  /** A bepipált találatok összege – ennyi hivatkozás módosulna. */
  migSzamol() {
    this.migOsszes = (this.migTalalatok || [])
      .filter((t: any) => t.valasztva).reduce((a: number, t: any) => a + Number(t.db || 0), 0);
  }

  migPipa(t: any) {
    if (t.kotelezo) return;          // az azonosító saját sora nélkül nincs értelme
    t.valasztva = !t.valasztva;
    this.migSzamol();
  }

  async migAtvezet() {
    if (!confirm(`Átvezeted a belépési azonosítót?\n\n${this.migRegi}\n   ↓\n${this.migUj}\n\n`
      + `${this.migOsszes} hivatkozás módosul. A művelet egyetlen tranzakcióban fut: `
      + `vagy minden átmegy, vagy semmi.\n\nFONTOS: a belépési rendszerben (Microsoft / Keycloak) `
      + `is az ÚJ címnek kell szerepelnie, különben a kolléga nem tud belépni.`)) return;
    this.migFut = true;
    try {
      const r: any = await firstValueFrom(this.http.post(
        '/api/nyilvantartas/allomany-azonosito/atvezetes',
        {
          regi: this.migRegi, uj: this.migUj,
          valasztott: (this.migTalalatok || [])
            .filter((t: any) => t.valasztva)
            .map((t: any) => ({ tabla: t.tabla, oszlop: t.oszlop })),
        }));
      this.data.sendToast(`Átvezetve: ${r?.osszes || 0} hivatkozás módosult.`, 'success');
      this.migTalalatok = null;
      if (this.activeAllomany) this.activeAllomany.adid = this.migUj;
      this.getAllomany();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'Az átvezetés nem sikerült.', 'error');
    } finally {
      this.migFut = false;
    }
  }

  initModal(row){
    this.segment = "1";
    this.migTalalatok = null;
    this.migOsszes = 0;
    this.activeAllomany = row;
    this.activeIntezmenyAdatok = null;

    const intezmenyadatokRaw = typeof row?.intezmenyadatok === 'string'
      ? JSON.parse(row.intezmenyadatok)
      : (row?.intezmenyadatok || []);

    const intezmenyadatok = Array.isArray(intezmenyadatokRaw)
      ? (intezmenyadatokRaw.find(d => d?.intezmenyId == this.sajatIntezmeny?.intezmenyId) || intezmenyadatokRaw[0])
      : null;

    this.activeIntezmenyAdatok = intezmenyadatok || {};
    this.form.reset({
      anyanyelv: { id: 142, nev: 'magyar' },
      allampolgar1: { id: 142, nev: 'magyar' },
      allampolgar2: { id: 142, nev: 'magyar' },
      szul_orszag: { id: 142, nev: 'Magyarország' },
      ped_fokozat: '0',
      munkaviszony: 0,
      foallas: 0,
      utazo_gyogyped: 0,
      csok_mi: 0,
      tartos_tavollet: 0,
      vezeto: 0,
      ttf: 0,
    });

    this.form.patchValue(row || {});
    this.form.patchValue(this.activeIntezmenyAdatok || {});

    if (row?.szul_datum) {
      this.form.patchValue({ szul_datum: moment(row.szul_datum).format('YYYY-MM-DD') });
    }
    if (this.activeIntezmenyAdatok?.jogviszony_kezd) {
      this.form.patchValue({ jogviszony_kezd: moment(this.activeIntezmenyAdatok.jogviszony_kezd).format('YYYY-MM-DD') });
    }
    if (this.activeIntezmenyAdatok?.jogviszony_vege) {
      this.form.patchValue({ jogviszony_vege: moment(this.activeIntezmenyAdatok.jogviszony_vege).format('YYYY-MM-DD') });
    }

    /*  A jogkör az `allomany_feladatellatas` sorban SZÖVEGKÉNT él, a választó viszont
     *  objektumot vár – enélkül a megnyitott adatlap üres jogkört mutatna, és a
     *  mentés törölné a meglévőt. */
    if (this.activeIntezmenyAdatok?.jogkor) {
      const talalt = (this.jogkorok || []).find(
        (j: any) => String(j.jogkor) === String(this.activeIntezmenyAdatok.jogkor));
      this.form.patchValue({ jogkor: talalt || null });
    } else {
      this.form.patchValue({ jogkor: null });
    }

    if (row?.szul_orszag && this.orszag) {
      this.form.patchValue({ szul_orszag: this.orszag.find(d => d.nev == row.szul_orszag) || row.szul_orszag });
    }
    if (row?.anyanyelv && this.allampolgar) {
      this.form.patchValue({ anyanyelv: this.allampolgar.find(d => d.nev == row.anyanyelv) || row.anyanyelv });
    }
    if (row?.allampolgar1 && this.allampolgar) {
      this.form.patchValue({ allampolgar1: this.allampolgar.find(d => d.nev == row.allampolgar1) || row.allampolgar1 });
    }
    if (row?.allampolgar2 && this.allampolgar) {
      this.form.patchValue({ allampolgar2: this.allampolgar.find(d => d.nev == row.allampolgar2) || row.allampolgar2 });
    }

    this.modal.present();
  }
  onSelect({ selected }) {
    console.log('Select Event', selected, this.selected);

    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }

  getEletut(){
    this.http
    .get(
      'https://merfoldkovek.oh.gov.hu/api/User/Timeline',
      {
        
      }
    )
    .subscribe({
      next: (response) => {
        //this.allomany = response
        console.log(response)
      },
      error: (error) => {
        console.error('Error fetching data:', error);
/*
{
    "allapot": "NincsMegFeliratkozva",
    "formatumVerzio": 1,
    "generalva": "0001-01-01T00:00:00",
    "adatok": null,
    "adatAllapot": "OsszeallitasAlatt",
    "leiratkozasOka": "Oktazonvaltozas",
    "leiratkozva": null,
    "letrehozva": null,
    "megtekintveUgyintezokent": false,
    "ugyintezoOktazon": null,
    "isSucceeded": true,
    "reasonOfFail": null,
    "muveletAzonosito": "67155014-3c68-47cc-802d-a68aee09ce1c",
    "errorCode": 0,
    "errorCodeString": "0000",
    "time": "2025-01-17T16:35:45.4874766+01:00"
} */
      },
    });
  }

  /*  KILÉPETT MUNKATÁRSAK.
   *
   *  A többi képernyő alapból csak az AKTÍVAKAT kapja meg (akinek nincs lezárva a
   *  jogviszonya) – ahogy a kiiratkozott tanuló sem jelenik meg a névsorokban. EZ a
   *  képernyő viszont az állomány karbantartása: itt látni kell a kilépettet is,
   *  különben nem lehetne se megnézni, se a lezárást visszavonni. Ezért kér `osszes=1`-et,
   *  és külön jelöli őket.
   */
  kilepettekIs = true;

  /** Lezárult-e a jogviszony EBBEN az intézményben? A dátum a feladatellátáson van. */
  kilepett(row: any): boolean {
    const ma = new Date(); ma.setHours(0, 0, 0, 0);
    let adatok = row?.intezmenyadatok;
    if (typeof adatok === 'string') { try { adatok = JSON.parse(adatok); } catch { adatok = []; } }
    const sajat = (Array.isArray(adatok) ? adatok : [])
      .find((d: any) => d?.intezmenyId === this.sajatIntezmeny?.intezmenyId);
    if (!sajat?.jogviszony_vege) return false;
    return new Date(sajat.jogviszony_vege) < ma;
  }

  getAllomany(){
    let headers={
      intezmeny: this.sajatIntezmeny.intezmenyId
    }
    this.http
      .get(
        '/api/nyilvantartas/allomany/'+this.sajatIntezmeny.intezmenyId
          + (this.kilepettekIs ? '?osszes=1' : ''),
        {
          headers: headers,
        }
      )
      .subscribe({
        next: (response) => {
          this.allomany = Array.isArray(response) ? response : []
          this.allomanySzurt = [...this.allomany]
          console.log(this.allomany)
        },
        error: (error) => {
          console.error('Error fetching data:', error);

        },
      });
      this.http
        .get(
          '/api/nyilvantartas/csoport/'+this.sajatIntezmeny.intezmenyId,
          {
            headers: headers,
          }
        )
        .subscribe({
          next: (response) => {
            this.csoport = response
            console.log(this.csoport)
          },
          error: (error) => {
            console.error('Error fetching data:', error);
  
          },
        });
        this.http
      .get(
        '/api/nyilvantartas/telepules/hu',
        {
          headers: headers,
        }
      )
      .subscribe({
        next: (response) => {
          this.telepules = response
        },
        error: (error) => {
          console.error('Error fetching data:', error);

        },
      });
      this.http
      .get(
        '/api/nyilvantartas/allampolgarsag',
        {
          headers: headers,
        }
      )
      .subscribe({
        next: (response) => {
          this.allampolgar = response
        },
        error: (error) => {
          console.error('Error fetching data:', error);

        },
      });
      this.http
        .get<any[]>('/api/jogosultsag/jogkorok/'
          + encodeURIComponent(this.alrendszer)
          + '/' + this.sajatIntezmeny.intezmenyId)
        .subscribe({
          next: (r) => { this.jogkorok = Array.isArray(r) ? r : []; },
          // Jogkörlista nélkül a mező üresen marad – az adatlap többi része működjön.
          error: () => { this.jogkorok = []; },
        });
      this.http
      .get(
        '/api/nyilvantartas/orszagok',
        {
          headers: headers,
        }
      )
      .subscribe({
        next: (response) => {
          this.orszag = response
        },
        error: (error) => {
          console.error('Error fetching data:', error);

        },
      });
  }

  getAllomanyRequiredFields() {
    this.http
      .get<any>('/api/nyilvantartas/allomany-required-fields')
      .subscribe({
        next: (response) => {
          this.allomanyRequiredFields = {
            allomany: Array.isArray(response?.allomany) ? response.allomany : [],
            allomany_feladatellatas: Array.isArray(response?.allomany_feladatellatas)
              ? response.allomany_feladatellatas
              : [],
          };
          this.applyDbRequiredValidators();
        },
        error: (error) => {
          console.error('Error fetching allomany required fields:', error);
        },
      });
  }

  private applyDbRequiredValidators() {
    Object.keys(this.form.controls).forEach((controlName) => {
      const control = this.form.get(controlName);
      if (!control) return;

      const isRequired = this.isDbRequiredControl(controlName);
      control.setValidators(isRequired ? [Validators.required] : []);
      control.updateValueAndValidity({ emitEvent: false });
    });
  }

  /**
   *  Csillag a kötelező mezők címkéje mellé.
   *
   *  A „kötelező" NEM kézzel karbantartott lista: az adatbázis mondja meg (NOT NULL,
   *  alapérték nélkül), és ugyanaz a forrás állítja be az űrlap-ellenőrzést is. Így a
   *  csillag és a mentés feltétele nem tud elcsúszni egymástól – ha egy telepítésen
   *  más oszlop kötelező, ott más mező kap csillagot.
   */
  /*  ÓRAADÓ (megbízás): nincs munkaidő-arány és nincs kötött munkaidő, csak a megtartott
   *  órák számítanak (Európa 2000, 2026-10-06). Az adatlapon ilyenkor az arány helyett a
   *  heti óraszám és az óradíj tölthető. A meghatározás: shared/oraado.ts. */
  readonly ORAADO_JOGVISZONY = ORAADO_JOGVISZONY;
  get oraado(): boolean {
    return oraadoJogviszony(this.form?.get('munkaviszony')?.value);
  }

  cs(controlName: string): string {
    return this.isDbRequiredControl(controlName) ? ' *' : '';
  }

  /** Van-e egyáltalán kötelező mező – a jelmagyarázatot csak akkor írjuk ki. */
  get vanKotelezoMezo(): boolean {
    return (this.allomanyRequiredFields.allomany.length
      + this.allomanyRequiredFields.allomany_feladatellatas.length) > 0;
  }

  private isDbRequiredControl(controlName: string): boolean {
    if (this.allomanyFormFields.has(controlName)) {
      return this.allomanyRequiredFields.allomany.includes(controlName);
    }

    if (this.allomanyFeladatellatasFormFields.has(controlName)) {
      return this.allomanyRequiredFields.allomany_feladatellatas.includes(controlName);
    }

    return false;
  }

  private getMissingRequiredLabels(): string[] {
    return Object.keys(this.form.controls)
      .filter((controlName) => this.form.get(controlName)?.hasError('required'))
      .map((controlName) => this.fieldLabels[controlName] || controlName);
  }

  private normalizal(value: any): string {
    return String(value ?? '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }

  szures() {
    const nev = this.normalizal(this.szuro.nev);
    const oktazon = this.normalizal(this.szuro.oktazon);
    const adid = this.normalizal(this.szuro.adid);

    this.selected = [];
    if (this.allomanyTable) this.allomanyTable.offset = 0;
    this.allomanySzurt = (this.allomany || []).filter((row) => {
      const teljesNev = this.normalizal([
        row?.viselt_elo,
        row?.viselt_vez,
        row?.viselt_ker,
      ].filter(Boolean).join(' '));
      const rowOktazon = this.normalizal(row?.oktazon);
      const rowAdid = this.normalizal(row?.adid);

      return (!nev || teljesNev.includes(nev))
        && (!oktazon || rowOktazon.includes(oktazon))
        && (!adid || rowAdid.includes(adid));
    });
  }

  szuresTorles() {
    this.szuro = {
      nev: '',
      oktazon: '',
      adid: '',
    };
    this.selected = [];
    if (this.allomanyTable) this.allomanyTable.offset = 0;
    this.allomanySzurt = [...(this.allomany || [])];
  }



  cancel() {
    this.modal.dismiss(null, 'cancel');
  }
  confirm(draft) {
    if (!this.activeAllomany?.adid) {
      this.data.sendToast('Nincs kiválasztott dolgozó.', 'error');
      return;
    }

    this.applyDbRequiredValidators();
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      const missing = this.getMissingRequiredLabels();
      this.data.sendToast(
        `Hiányzó kötelező mező${missing.length > 1 ? 'k' : ''}: ${missing.join(', ')}`,
        'error'
      );
      return;
    }

    const raw = this.form.getRawValue();
    const normalizeSelectableValue = (value, fallback = '') => {
      if (value && typeof value === 'object') {
        return value.nev || value.full_name_irsz || fallback;
      }
      return value ?? fallback;
    };
    const asIntBool = (value) => (value ? 1 : 0);

    const allomanyPayload = {
      ...this.activeAllomany,
      adid: this.activeAllomany.adid,
      viselt_elo: raw.viselt_elo,
      viselt_vez: raw.viselt_vez,
      viselt_ker: raw.viselt_ker,
      szul_elo: raw.szul_elo,
      szul_vez: raw.szul_vez,
      szul_ker: raw.szul_ker,
      anya_elo: raw.anya_elo,
      anya_vez: raw.anya_vez,
      anya_ker: raw.anya_ker,
      taj: raw.taj,
      adoazon: raw.adoazon,
      ig_tipus: raw.ig_tipus,
      ig_szam: raw.ig_szam,
      szul_datum: raw.szul_datum || null,
      oktazon: raw.oktazon,
      szul_hely: normalizeSelectableValue(raw.szul_hely, raw.szul_hely),
      szul_orszag: normalizeSelectableValue(raw.szul_orszag, raw.szul_orszag),
      anyanyelv: normalizeSelectableValue(raw.anyanyelv, raw.anyanyelv),
      allampolgar1: normalizeSelectableValue(raw.allampolgar1, raw.allampolgar1),
      allampolgar2: normalizeSelectableValue(raw.allampolgar2, raw.allampolgar2),
      nem: raw.nem,
      email: raw.email,
      telefonszam: raw.telefonszam,
      /*  A LAKCÍM ÉS A VÉGZETTSÉG IS AZ ŰRLAPRÓL JÖN. A payload a betöltött sorból indul
       *  (`...this.activeAllomany`), és csak a felsorolt mezőket írja felül az űrlap
       *  értékével – ezek kimaradtak, így a mentés csendben a RÉGI címet írta vissza
       *  (2026-09-30: „átírtam az állandó lakcímemet, de nem módosult”). Az állandó cím
       *  irányítószáma szám oszlop: az üres mező NULL, nem üres szöveg. */
      all_cim_irsz: raw.all_cim_irsz === '' || raw.all_cim_irsz == null ? null : raw.all_cim_irsz,
      all_cim_telepules: raw.all_cim_telepules,
      all_cim_kozter: raw.all_cim_kozter,
      all_cim_kozter_jelleg: raw.all_cim_kozter_jelleg,
      all_cim_hsz: raw.all_cim_hsz,
      all_cim_pontositas: raw.all_cim_pontositas,
      tart_cim_irsz: raw.tart_cim_irsz,
      tart_cim_telepules: raw.tart_cim_telepules,
      tart_cim_kozter: raw.tart_cim_kozter,
      tart_cim_kozter_jelleg: raw.tart_cim_kozter_jelleg,
      tart_cim_hsz: raw.tart_cim_hsz,
      tart_cim_pontositas: raw.tart_cim_pontositas,
      vegzettseg: raw.vegzettseg,
    };

    /*  A JOGKÖRT AZ ADATLAP NEM ÍRJA. A választó 2026-09-10 óta nincs a képernyőn (a
     *  jogkör a Jogkörök képernyőn kezelhető), a rejtett mező viszont a tárolt
     *  `["pedagogus"]` alakot nem ismerte fel, és a mentés NULL-ra írta: a tanár
     *  elvesztette a naplóját. Ezért a mentésből kimarad – a tárolt érték is. */
    const { jogkor: _jogkor, ...intezmenyAdatokJogkorNelkul } = this.activeIntezmenyAdatok || {};
    const allomanyFeladatellatasPayload = {
      ...intezmenyAdatokJogkorNelkul,
      allomany: this.activeAllomany.adid,
      feladatellatas:
        this.activeIntezmenyAdatok?.intezmenyId ||
        this.activeIntezmenyAdatok?.feladatellatas ||
        this.sajatIntezmeny?.intezmenyId,
      munkakor: raw.munkakor,
      szszam: raw.szszam,
      jogviszony_kezd: raw.jogviszony_kezd || null,
      jogviszony_vege: raw.jogviszony_vege || null,
      foallas: asIntBool(raw.foallas),
      ped_fokozat: raw.ped_fokozat,
      munkaviszony: raw.munkaviszony,
      utazo_gyogyped: asIntBool(raw.utazo_gyogyped),
      csok_mi: asIntBool(raw.csok_mi),
      tartos_tavollet: asIntBool(raw.tartos_tavollet),
      vezeto: asIntBool(raw.vezeto),
      ttf: asIntBool(raw.ttf),
      /*  Óraadónál az arány üres (NULL), helyette a heti óraszám; másnál fordítva. A szám
       *  oszlopok üres szövege NULL – a szigorú SQL-mód az üres szöveget elutasítaná. */
      reszm_arany: oraadoJogviszony(raw.munkaviszony) || raw.reszm_arany === '' || raw.reszm_arany == null
        ? null : Number(String(raw.reszm_arany).replace(',', '.')) || null,
      heti_oraszam: oraadoJogviszony(raw.munkaviszony) ? hetiOraszam(raw.heti_oraszam) : null,
      megbizasi_oradij: raw.megbizasi_oradij === '' || raw.megbizasi_oradij == null
        ? null : Math.round(Number(String(raw.megbizasi_oradij).replace(',', '.'))) || null,
      /*  A napi km szám (float) oszlop: az üres mező NULL, nem üres szöveg – az
       *  utóbbit a szigorú SQL-mód elutasítaná. Tizedesvesszőt is elfogadunk. */
      benzinkm: raw.benzinkm === '' || raw.benzinkm == null
        ? null : Number(String(raw.benzinkm).replace(',', '.')) || 0,
      utazas_utvonal: (raw.utazas_utvonal || '').trim() || null,
      utazas_eszkoz: (raw.utazas_eszkoz || '').trim() || null,
      utazas_rendszam: (raw.utazas_rendszam || '').trim().toUpperCase() || null,
    };

    const payload = {
      allomany: allomanyPayload,
      allomany_feladatellatas: allomanyFeladatellatasPayload,
    };

    this.http.post('/api/nyilvantartas/allomany/save', payload).subscribe({
      next: () => {
        this.data.sendToast('Sikeres mentés', 'success');
        this.modal.dismiss(null, 'confirm');
        this.getAllomany();
      },
      error: (error) => {
        const requiredFields = error?.error?.requiredFields;
        const missing = [
          ...(requiredFields?.allomany || []),
          ...(requiredFields?.allomany_feladatellatas || []),
        ].map((field) => this.fieldLabels[field] || field);
        this.data.sendToast(
          missing.length
            ? `Sikertelen mentés, hiányzó kötelező mező${missing.length > 1 ? 'k' : ''}: ${missing.join(', ')}`
            : 'Sikertelen mentés',
          'error'
        );
      },
    });
  }

  selectChangedAnyanyelv(e){

  }

}
